import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DomainRichPlacementMultiAnchorConfigurationDTO } from '../types/domainRichPlacementMultianchorConfigurationDTO'

export const DOMAIN_RICH_PLACEMENT_MULTI_ANCHOR_CONFIGURATION_FRAGMENT: TypedDocumentNode<DomainRichPlacementMultiAnchorConfigurationDTO> = gql`
  fragment DomainRichPlacementMultiAnchorConfigurationFragment on DomainRichPlacementMultianchorConfiguration {
    customizeApperanceEnabled
    customizeBasicSettingsEnabled
    customStyling
    displayAfterUserInteractionEnabled
    fullWidthModeEnabled
    enabled
    showCloseButtonEnabled
    singleAdViewTime
  }
`
